export interface ApiError {
  error: {
    message: string;
    type: string;
    param: string;
    code: ApiErrorCode;
  };
}

export interface ApiHttpError {
  status: number;
  statusText: string;
  url: string;
  ok: boolean;
  name: string;
  message: string;
  error: ApiError;
}

export enum ApiErrorCode {
  ContextLengthExceeded = 'context_length_exceeded',
}
